<template>
  <div class="select" ref="selectRef">
    <div
      :class="{ disabled: options.length < 1 || !value }"
      class="select__option"
      @click="toggleDropdown"
    >
      <div class="select__title" v-html="selectedOptionTitle"></div>
      <img src="@/assets/img/order/dropdown.svg" />
    </div>
    <ul v-show="isOpen && options.length > 0" class="select__list">
      <li
        v-for="option in options"
        :key="option.value"
        @click="selectOption(option)"
        :class="{ list__active: value === option.value }"
      >
        <span v-html="option.title"></span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["options", "value", "placeHolder"],
  data() {
    return {
      isOpen: false
    };
  },
  watch: {
    options(newOptions) {
      if (newOptions.length > 0) {
        this.selectOption(newOptions[0]);
      }
    },
    value() {
      this.$emit("changeValue", this.value);
    }
  },
  computed: {
    selectedOptionTitle() {
      const selectedOption = this.options.find(
        (option) => option.value === this.value
      );
      return selectedOption ? selectedOption.title : this.placeHolder;
    }
  },
  mounted() {
    document.addEventListener("click", this.handleOutsideClick);
  },
  destroyed() {
    document.removeEventListener("click", this.handleOutsideClick);
  },
  created() {},
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    selectOption(option) {
      this.$emit("input", option.value);
      this.isOpen = false;
    },
    handleOutsideClick(event) {
      if (!this.$refs.selectRef.contains(event.target)) {
        this.isOpen = false;
      }
    }
  }
};
</script>

<style src="./layout.css" scoped></style>
